import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const STATE = ['absent (without notice)', 'attended', 'absent (with excuse)']

export const schema = Joi.object().keys({
	start_date: Joi.string().required(),
	end_date: Joi.string().required(),
	class_id_list: Joi.array().allow(''),
	state: Joi.string().valid(STATE).allow(''),
	amount_per_page: Joi.number().integer().allow(''),
	current_page_number: Joi.number().integer().allow(''),
});

export default function teacherAttendanceRecord(teacherId, attendanceInfo) {

  if(!teacherId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing teacher Id (number)')
      })
    })
  }

  let validateResult = Joi.validate(attendanceInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...attendanceInfo,
    state: !attendanceInfo.state ? '' : STATE.indexOf(attendanceInfo.state),
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/t_check_rcd/${teacherId}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/teacher/teacherAttendanceRecord.js